import request from '@/utils/request'
//get
export function getStaffServiceParam(param) {
    return request({
        url: `/staff_service/${param}`,
        method: 'GET'
    })
}
export function buyPrice(data) {
    return request({
        url: `/staff_service/buy_price/`,
        method: 'POST',
        data
    })
}

export function buy(data) {
    return request({
        url: `/staff_service/buy/`,
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/staffService.js